export class PetProfileLastEntryModel {
    body_score: number
    body_score_date: string
    weight: number
    weight_date: string
    temp: number
    temp_date: string

    constructor(
        body_score: number,
        body_score_date: string,
        weight: number,
        weight_date: string,
        temp: number,
        temp_date: string,
    ) {
        this.body_score = body_score
        this.body_score_date = body_score_date
        this.weight = weight
        this.weight_date = weight_date
        this.temp = temp
        this.temp_date = temp_date
    }
}